import React from 'react';
import PropTypes from 'prop-types';
import {
  kebabCase,
} from 'lodash/fp';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { geographySelector } from 'selectors/basic'; // @todo is this the right place?

// Components
import { Helmet } from 'react-helmet';
import Breadcrumb from 'components/breadcrumb';
import ModalMenu from 'components/modalMenu';

// Styles
import styles from './geographyHeader.scss';

/**
 * Given the parameters, build an array to pass to the breadcrumb component.
 * @param  {string} dataView  The category of this geography
 * @param  {object} parent    The geography object of a parent, if present
 * @param  {string} geography The name of the current geography.
 * @return {array}            Array of objects as needed for <Breadcrumb />
 */
function buildBreadcrumbs(dataView, parent, geography) {
  // If there is no dataView, bail.
  if (!dataView) {
    return [];
  }

  const items = [
    {
      label: 'usdata' === dataView ?
        'United States Indicators' :
        'International Data',
      destination: `/${dataView}`,
    },
  ];

  if (parent && 0 < Object.keys(parent).length) {
    items.push({
      label: parent.geography,
      destination: `/${dataView}/geography/${kebabCase(parent.geography)}`,
    });
  }

  if (geography) {
    items.push({
      label: geography,
      destination: `/${dataView}/geography/${kebabCase(geography)}`,
    });
  }

  return items;
}

/**
 * Component that shows the top section of a geography page.
 */
const GeographyHeader = ({
  info: {
    geography: {
      geography,
      dataView,
      parent = {},
    } = {},
  },
  match: {
    params: {
      category,
    },
  },
  children,
  childGeographies,
  parentName,
}) => (
  <div className={styles.geographyHeader}>
    <Helmet>
      <title>
        {`${'usdata' === dataView ? 'U.S. Indicators' : 'International Data'}: ${geography} - PRB`}
      </title>
    </Helmet>
    <div className={styles.wrapper}>
      <h1 className={styles.title}>
        {geography}
      </h1>
      <div className={styles.breadcrumb}>
        <Breadcrumb items={buildBreadcrumbs(dataView, parent, geography)} />
      </div>
    </div>
    <div className={styles.menu}>
      {'usdata' === category && 1 < childGeographies.length && parent &&
        <ModalMenu
          label="View by county"
          title={`Counties in ${geography}`}
          buttonClassName={styles.button}
        >
          <ul className={styles.list}>
            {childGeographies
              .sort((a, b) => (a.geography < b.geography ? -1 : 1))
              .map(({ geography: childGeography, code }) => (
                <li key={code} className={styles.item}>
                  <Link
                    to={`/${dataView}/geography/${code}`}
                    className={styles.link}
                  >
                    {childGeography}
                  </Link>
                </li>
              ))}
          </ul>
        </ModalMenu>
      }
      {parentName && ('United States' !== parentName) && (
        <Link
          to={`/${category}/geography/${kebabCase(parentName)}`}
          className={styles.backButton}
        >
          Back to {parentName}
        </Link>
      )}
    </div>
    {children}
  </div>
);

GeographyHeader.defaultProps = {
  children: null,
  childGeographies: [],
  parentName: false,
};

GeographyHeader.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  info: PropTypes.shape({
    geography: PropTypes.shape({
      geography: PropTypes.string,
      dataView: PropTypes.string,
      parent: PropTypes.shape({
        geography: PropTypes.string,
      }),
    }),
  }).isRequired,
  childGeographies: PropTypes.arrayOf(PropTypes.shape({
    geography: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    dataView: PropTypes.string.isRequired,
  })),
  parentName: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  children: PropTypes.node,
};

const mapStateToProps = (state) => ({
  info: geographySelector(state),
});

export default connect(mapStateToProps)(withRouter(GeographyHeader));



// WEBPACK FOOTER //
// ./app/components/geographyHeader/index.js